import { styled, Box } from '@ltvco/refresh-lib';

export const StyledApiFeatureBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  minWidth: '144px',
  maxWidth: '160px',
  margin: `${theme.spacing(0.5)} auto`,
}));
